import React from 'react';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';

import type { BillingAccount } from '../../graphql/types';
import type {
  AppStackParamList,
  ModalStackParamList,
} from '../../navigation/AppNavigation.props';

export const useScanToPayNavigation = () => {
  const {
    handleOpenScanToPay,
    handleSelectPaymentMethod,
    handleSelectAddPaymentMethod,
  } = useAppStackNavigation();
  const navigation =
    useNavigation<NativeStackNavigationProp<ModalStackParamList>>();

  const goToOptions = React.useCallback(() => {
    navigation.navigate('ScanToPay');
  }, [navigation]);

  const goToPayments = React.useCallback(() => {
    navigation.navigate('Payments');
  }, [navigation]);

  const goToGiftCode = React.useCallback(() => {
    navigation.navigate('CreditAdd');
  }, [navigation]);

  const goBack = React.useCallback(() => {
    if (navigation.canGoBack()) navigation.goBack();
    else goToOptions();
  }, [navigation, goToOptions]);

  return {
    handleOpenScanToPay,
    handleSelectPaymentMethod,
    handleSelectAddPaymentMethod,
    goToOptions,
    goToPayments,
    goToGiftCode,
    goBack,
  };
};

const useAppStackNavigation = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<AppStackParamList>>();
  const handleOpenScanToPay = React.useCallback(() => {
    navigation.navigate('Modal', { screen: 'ScanToPay' });
  }, [navigation]);
  const handleSelectPaymentMethod = React.useCallback(
    ({ id }: BillingAccount) => {
      navigation.navigate('Modal', {
        screen: 'PaymentMethodEdit',
        params: { paymentMethodId: id },
      });
    },
    [navigation],
  );
  const handleSelectAddPaymentMethod = React.useCallback(() => {
    navigation.navigate('Modal', {
      screen: 'PaymentMethodAdd',
    });
  }, [navigation]);

  return {
    handleOpenScanToPay,
    handleSelectPaymentMethod,
    handleSelectAddPaymentMethod,
  };
};
